import { generateActions } from '../utils';
import { API_CONST } from '../middlewares/api';
import { handleActions, createAction } from 'redux-actions';

const initial = {
  role: null,
}

const postActions = generateActions('users/info/SET_PERSON_ENTER');
const postViewVisit = generateActions('users/info/SET_VIEW_VISIT');
const postViewLot = generateActions('users/info/SET_VIEW_LOT');
  
//фиксируем первый вход пользователя под ролью 
export const sendFirstEnter = createAction(
  API_CONST,
  () => ({
    method: 'POST',
    url: `auth/person/firstenter`,
    actions: postActions
  })
)

export const sendFirstVisitView = createAction(
  API_CONST,
  (visitId) => ({
    method: 'POST',
    url: `visits/${visitId}/firstviewvisit`,
    actions: postViewVisit
  })
)

export const sendFirstLotView = createAction(
  API_CONST,
  (lotId) => ({
    method: 'POST',
    url: `lots/${lotId}/firstviewlot`,
    actions: postViewLot
  })
)

export default handleActions({
  [postActions[0]]: state => ({ ...initial }),
  [postActions[1]]: (state, { payload = {} }) => ({...state, role: payload}),

  [postViewVisit[0]]: state => ({ ...initial }),
  [postViewVisit[1]]: (state, { payload = {} }) => ({...state, role: payload}),

  [postViewLot[0]]: state => ({ ...initial }),
  [postViewLot[1]]: (state, { payload = {} }) => ({...state, role: payload})
}, initial)


// WEBPACK FOOTER //
// ./src/store/reducers/role.js